<div class="container" [fxLayout]="isMobile() ? 'column' : 'row'">
    <div class="table-wrapper" fxLayout="column" fxFlex="50">
        <dsn-expand-collapse
            [isExpanded]="true"
            [label]="'Balanço Patrimonial Ativo'"
            [type]="'transparent'"
            [horizontalPadding]="true"
            [fontSize]="'medium'"
            [disabled]="pdf"
        >
            <div
                fxLayout="column"
                class="table-content"
                [@staggerAnimation]="assetsAccounts.length"
            >
                @if (!loading()) {
                    @for (account of assetsAccounts; track account.serie._id) {
                        @if (
                            expandedAccountsAssets.includes(account.serie._id)
                        ) {
                            <app-balance-account-card
                                [@balanceCardAnimation]
                                [type]="account.type"
                                [serie]="account.serie"
                                [base]="account.base"
                                [comparation]="account.comparation"
                                [ah]="account.ah"
                                [isExpanded]="account.isExpanded"
                                [hideExpandButton]="pdf"
                                [pdf]="pdf"
                                (handleExpand)="onExpandAssets(account)"
                            ></app-balance-account-card>
                        }
                    }
                    @if (!pdf) {
                        <dsn-button
                            [iconLeft]="
                                hideZeroAccountsAssets()
                                    ? 'fa-solid fa-eye'
                                    : 'fa-solid fa-eye-slash'
                            "
                            [label]="
                                hideZeroAccountsAssets()
                                    ? 'Mostrar contas zeradas'
                                    : 'Ocultar contas zeradas'
                            "
                            type="secondary"
                            [size]="'small'"
                            style="
                                margin-left: auto;
                                margin-top: var(--spacing-8);
                            "
                            (click)="onToggleZeroAccountsAssets()"
                        ></dsn-button>
                    }
                } @else {
                    @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track $index) {
                        <dsn-skeleton-loader
                            [width]="'100%'"
                            [height]="'64px'"
                            [type]="'rectangle'"
                        ></dsn-skeleton-loader>
                    }
                }
            </div>
        </dsn-expand-collapse>
    </div>
    <div class="table-wrapper" fxLayout="column" fxFlex="50">
        <dsn-expand-collapse
            [isExpanded]="true"
            [label]="'Balanço Patrimonial Passivo'"
            [type]="'transparent'"
            [horizontalPadding]="true"
            [fontSize]="'medium'"
            [disabled]="pdf"
        >
            <div
                fxLayout="column"
                class="table-content"
                [@staggerAnimation]="liabilitiesAccounts.length"
            >
                @if (!loading()) {
                    @for (
                        account of liabilitiesAccounts;
                        track account.serie._id
                    ) {
                        @if (
                            expandedAccountsLiabilities.includes(
                                account.serie._id
                            )
                        ) {
                            <app-balance-account-card
                                [@balanceCardAnimation]
                                [type]="account.type"
                                [serie]="account.serie"
                                [base]="account.base"
                                [comparation]="account.comparation"
                                [ah]="account.ah"
                                [isExpanded]="account.isExpanded"
                                [hideExpandButton]="pdf"
                                [pdf]="pdf"
                                (handleExpand)="onExpandLiabilities(account)"
                            ></app-balance-account-card>
                        }
                    }
                    @if (!pdf) {
                        <dsn-button
                            [iconLeft]="
                                hideZeroAccountsLiabilities()
                                    ? 'fa-solid fa-eye'
                                    : 'fa-solid fa-eye-slash'
                            "
                            [label]="
                                hideZeroAccountsLiabilities()
                                    ? 'Mostrar contas zeradas'
                                    : 'Ocultar contas zeradas'
                            "
                            type="secondary"
                            [size]="'small'"
                            style="
                                margin-left: auto;
                                margin-top: var(--spacing-8);
                            "
                            (click)="onToggleZeroAccountsLiabilities()"
                        ></dsn-button>
                    }
                } @else {
                    @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track $index) {
                        <dsn-skeleton-loader
                            [width]="'100%'"
                            [height]="'64px'"
                            [type]="'rectangle'"
                        ></dsn-skeleton-loader>
                    }
                }
            </div>
        </dsn-expand-collapse>
    </div>
</div>
